export default "__VITE_ASSET__BQY$PkB7__"